(function (upp, $) {
    'use strict';

    upp.directive('fullscreenPreview', function () {
        return {
            restrict: 'E',
            template: '' +
                '<div class="fullscreen-preview" data-ng-show="opened" data-ng-if="images.length > 0">' +
                '   <div class="fullscreen-close" data-ng-click="close()">&times;</div>' +
                '   <div class="preview-carousel-slider product-slider" data-images="images" ' +
                '       data-preview-type="slider" data-default-screen="{{ defaultScreen }}" data-fullscreen="false"></div>' +
                '</div>',
            replace: true,
            controller: ['$scope', function ($scope) {
                var resetValues = function ($scope) {
                    $scope.images = [];
                    $scope.defaultScreen = 0;
                    $scope.opened = false;
                };
                resetValues($scope);

                $scope.$on('upp:preview:open', function (e, index, images) {
                    $scope.opened = true;
                    $scope.defaultScreen = index;
                    $scope.images = images;
                    
                    setTimeout(function () {
                        rescaleImages();
                    }, 200);
                });

                $scope.close = function () {
                    resetValues($scope);
                };
                
                var rescaleImages = function () {
                    var listItems = $('.fullscreen-preview').find('ul.slides').find('li'),
                        h = window.innerHeight,
                        w = window.innerWidth;

                    var scale = function (img, height, width) {
                        img.css({
                            height: height + 'px',
                            width: width + 'px'
                        });
                    };

                    var center = function (img, height, width) {
                        var offsetTop = (h - height) / 2,
                            offsetLeft = (w - width) / 2;
                        
                        img.css({
                            marginLeft: offsetLeft + 'px',
                            marginTop: offsetTop + 'px',
                            opacity: 1
                        });
                    };
                    
                    $.each(listItems, function (i, el) {
                        var img = $(el).find('img'),
                            height = img.height(),
                            width = img.width();
                        
                        if (height > h) {
                            var desiredWidth = h * width / height;
                            scale(img, h, desiredWidth);
                            center(img, h, desiredWidth);
                        } else if (width > w) {
                            var desiredHeight = w * height / width;
                            scale(img, desiredHeight, w);
                            center(img, desiredHeight, w);
                        } else {
                            center(img, height, width);                          
                        }
                    });
                };
                
                rescaleImages();
                $(window).on('resize', rescaleImages);
            }]
        };
    });

    upp.directive('previewCarouselSlider',
        function () {
            return {
                restrict: 'C',
                scope: {
                    images: '='
                },
                template: '' +
                    '<div class="flexslider">' +
                    '  <ul class="slides">' +
                    '    <li data-ng-repeat="image in images">' +
                    '        <img data-ng-class="{\'cursor-pointer\': fullscreen}" data-ng-src="{{image.url}}" data-ng-click="openSlider($index)" />' +
                    '    </li>' +
                    '  </ul>' +
                    '</div>',
                replace: true,
                controller: ['$scope', function ($scope) {
                    $scope.openSlider = function (index) {
                        if ($scope.fullscreen) {
                            $scope.$emit('upp:preview:open', index, $scope.images);
                        }
                    }
                }],
                link: function ($scope, element, attrs) {
                    var type, props;

                    $scope.$watch('images', function (images) {
                        if (images) {
                            type = attrs['previewType'];
                            $scope.type = type;
                            $scope.fullscreen = attrs['fullscreen'] === 'true';
                            var defaultScreen = attrs['defaultScreen'] ? Number(attrs['defaultScreen']) : 0;

                            if (!type) {
                                throw new Error("no type defined");
                            } else if (images.length < 1) {
                                throw new Error("no images");
                            } else {
                                if (type === "carousel") {
                                    if (images.length > 1) {
                                        props = {
                                            animation: "slide",
                                            controlNav: false,
                                            animationLoop: false,
                                            slideshow: false,
                                            itemWidth: 80,
                                            itemMargin: 5,
                                            asNavFor: '#slider',
                                            startAt: defaultScreen
                                        };
                                    }
                                } else if (type === "slider") {
                                    props = {
                                        animation: "slide",
                                        controlNav: false,
                                        animationLoop: false,
                                        slideshow: false,
                                        sync: "#carousel",
                                        startAt: defaultScreen
                                    };
                                } else {
                                    throw new Error("type of carousel-slider not recognized");
                                }

                                if (props) {
                                    element.attr('id', type).flexslider(props);
                                } else {
                                    element.hide();
                                }
                            }

                        }
                    });

                }
            }
        });

})(upp, jQuery);


// WEBPACK FOOTER //
// ./src/app/common/directives/preview_carousel_slider-directive.js